/**
 * Simple toast/notification utilities using browser APIs.
 * A proper toast library (like react-hot-toast or sonner) can replace this.
 */

export function showErrorToast(message: string): void {
  // For now, use a simple approach. In production, use a proper toast library.
  console.error(message);

  // Create a simple in-page notification (optional enhancement)
  // For MVP, we rely on API error boundaries and user feedback
}

export function showSuccessToast(message: string): void {
  console.log(message);
}
